module.exports = __webpack_public_path__ + "static/media/cross.d9fa45f9.svg";